.createNewBoxButton {
  margin: 20px;
}

.row {
  padding-top: 16px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
}

.savedTemplatesButton:hover { background: none !important; }
.savedTemplatesButton {
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: -16px;
  margin-bottom: -16px;
}

.rowHeader { margin-top: 0px; }
.modal { width: min(80rem, 70vw); }

.bulkDimsModal {
  position: relative;
  overflow-y: auto;
}

.addTemplatesInput {
  min-width: 3.5em;
  width: 3.5em;
  margin-right: 6px;
}

.modalFooter {
  bottom: 0;
  position: sticky;
}

.modalHeader {
  top: 0;
  position: sticky;
}

.allBoxesCheckedCheckbox {
  margin-right: 1ch;
}

.arrowButton {
  border-radius: 8px;
  width: 24px;
  height: 24px;
}
